// extracted by mini-css-extract-plugin
module.exports = {"modalMainContainer":"VideoPlayerModal_modalMainContainer__3PdSY","videoPlayer":"VideoPlayerModal_videoPlayer__3u35Z"};